// extracted by mini-css-extract-plugin
export default {"inner":"suggestion_inner__2DRUq","container":"suggestion_container__2T_aW","carouselSlot":"suggestion_carouselSlot__129jC","carouselCard":"suggestion_carouselCard__1-DBa"};